"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

export const initializeSidenav = () => {
  const sideNavItem = document.querySelectorAll(".side-nav__item");

  //spのサイドナビ
  const sideNavBtn = document.getElementById("js-side-nav-btn");
  const sideNav = document.getElementById("js-side-nav");

  const sideNavBtnIcon = document.getElementById("js-side-btn-nav-icon");
  const sideNavBtnIconClose = document.getElementById(
    "js-side-btn-nav-icon-close"
  );
  // sideNavBtn が存在しない場合、関数の実行を中止
  if (!sideNavBtn) return;
  sideNavBtn.addEventListener("click", () => {
    sideNavBtn.classList.toggle("is-active");
    sideNav.classList.toggle("is-active");

    sideNavBtnIcon.classList.toggle("is-active");
    sideNavBtnIconClose.classList.toggle("is-active");
  });

  //リンク押した時

  sideNavBtnIconClose.addEventListener("click", (e) => {
    sideNavBtn.classList.remove("is-active");
    sideNav.classList.remove("is-active");

    sideNavBtnIcon.classList.add("is-active");
    sideNavBtnIconClose.classList.remove("is-active");
  });

  sideNavItem.forEach((link) => {
    link.addEventListener("click", (e) => {
      sideNavBtn.classList.remove("is-active");
      sideNav.classList.remove("is-active");

      sideNavBtnIcon.classList.add("is-active");
      sideNavBtnIconClose.classList.remove("is-active");
    });
  });
  //（sp時） サイドナビのボタンの表示・非表示のタイミング
  const containerFoot = document.querySelector(".footer");
  const sideNavLeft = document.getElementById("js-side-nav-left");

  ScrollTrigger.create({
    trigger: containerFoot,
    start: "top bottom",
    once: false,
    // markers: true,q
    onEnter: () => {
      sideNavLeft.classList.remove("is-active");
    },
    onLeaveBack: () => {
      sideNavLeft.classList.add("is-active");
    },
  });

  // active時のサイドナビ
  const sidenavBlock = document.querySelectorAll(".js-scroll-sidenav-block");

  const sideNavBtnTxt = document.getElementById("js-side-nav-btn-txt");

  sidenavBlock.forEach((item, index) => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 125px",
      end: "bottom 125px",
      once: false,
      // markers: true,
      onEnter: () => {
        sideNavAnime(item);
      },
      onEnterBack: () => {
        sideNavAnime(item);
      },
    });
  });

  const sidenavBlockBusiness = document.querySelectorAll(
    ".js-scroll-sidenav-block"
  );
  sidenavBlockBusiness.forEach((item, index) => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 415px",
      end: "bottom 415px",
      once: false,
      // markers: true,
      onEnter: () => {
        sideNavAnime(item);
      },
      onEnterBack: () => {
        sideNavAnime(item);
      },
    });
  });

  function sideNavAnime(item) {
    const dataBlock = item.dataset.block;
    const sideNavTxtNum = document.getElementById(
      `js-side-nav-txt-${dataBlock}`
    );
    const sideNavTxt = sideNavTxtNum.dataset.text;

    for (let i = 0; i < sideNavItem.length; i++) {
      sideNavItem[i].classList.remove("is-active");
      sideNavItem[dataBlock - 1].classList.add("is-active");
    }
    sideNavBtnTxt.textContent = sideNavTxt;
  }

  // window.addEventListener("scroll", () => {
  //   ScrollTrigger.refresh();
  // });
};
